<template>
  <div class="min-vh-100 bg-light">
    <div class="d-flex justify-content-center align-items-center m-3">
      <b-row class="app-login-box d-block mx-0">
        <div class="d-flex justify-content-center w-auto">
          <img
            src="@/assets/images/logo-login.png"
            height="100px"
            class="d-block img-fluid logo-img"
          />
        </div>
        <div class="mx-auto mb-3" />
        <div class="modal-dialog w-100 mx-auto form-dialog">
          <div v-if="checkRef === false && !isWaiting" class="modal-content">
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">
                  <span>Checking the data...</span>
                </h4>
              </div>
            </div>
          </div>

          <div v-if="isWaiting" class="modal-content">
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">Data verification failed</h4>
                <h4 class="mt-2">
                  <span>Will try again in {{ countdown }} seconds.</span>
                </h4>
              </div>
            </div>
          </div>

          <div
            v-if="checkRef === true && noref === true && !isWaiting"
            class="modal-content"
          >
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">
                  <span style="color: red"
                    >This user cannot enroll new members!</span
                  >
                </h4>
              </div>
            </div>
          </div>

          <div
            v-if="checkRef === true && noref === false && !isWaiting"
            class="modal-content"
          >
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">
                  <span>Create a new account</span>
                </h4>
              </div>
              <register-form :refferal.sync="referral" />
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import RegisterForm from "@/components/UserPages/RegisterForm";

export default {
  components: {
    RegisterForm,
  },
  data: () => ({
    slickOptions6: {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
      allowed: false,
    },
    slide: 0,
    sliding: null,
    referral: "",
    noref: false, // Privzeto nastavljeno na false, da ne povzroča napačnega ujemanja pogojev na začetku
    checkRef: false, // Ali smo preverili ref
    isWaiting: false, // Ali trenutno čakamo na nov poskus
    countdown: 30, // Števec sekund
    retryTimer: null, // Glavni 30-sekundni časovnik
    countdownTimer: null, // Časovnik, ki vsako sekundo posodablja števec na zaslonu
  }),

  created() {
    // Zagon komponente - sprožimo klic (samo enkrat definiran created kavelj!)
    this.fetchData();
  },

  mounted() {
    if (this.$route.params.inviteId) {
      this.referral = this.$route.params.inviteId;
    }
  },

  beforeDestroy() {
    // Ko uporabnik zapusti stran, obvezno uničimo vse časovnike
    this.clearAllTimers();
  },

  methods: {
    async fetchData() {
      // Pred novim poskusom prekinemo stanje čakanja in počistimo stare časovnike
      this.clearAllTimers();
      this.isWaiting = false;

      try {
        const url = `${this.baseURL}/admin-api/v1/ref?inviteId=${this.$route.params.inviteId}`;
        const res = await this.axios.get(url);

        // Če je klic uspešen (200 OK):
        this.checkRef = true;
        this.noref = res.data.noref;
      } catch (error) {
        console.error("Prišlo je do napake pri klicu:", error);
        // Za vse napake sprožimo odštevanje in ponovni klic
        this.startCountdown();
      }
    },

    startCountdown() {
      this.isWaiting = true;
      this.countdown = 30; // Ponastavimo števec na 30

      // Časovnik, ki vsakih 5 sekund vizualno zmanjša številko na zaslonu
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 5;
        }
      }, 5000);

      // Glavni časovnik, ki čez 30 sekund znova izvede API klic
      this.retryTimer = setTimeout(() => {
        this.fetchData();
      }, 30000);
    },

    clearAllTimers() {
      // Varno počistimo oba časovnika, če obstajata
      if (this.retryTimer) {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },

    handleClick(newTab) {
      this.currentTab = newTab;
    },
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>